import { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { apiSae } from "../services/api";
import { HomeContext } from "./ContextHome";

export const ElevatoriaContext = createContext({});

export const ElevatoriaProvider = () => {
  const { headerApi } = useContext(HomeContext);

  const [geradores, setGeradores] = useState([]);
  const [dadosControle, setDadosControle] = useState({});
  const [idBombasLoading, setidBombasLoading] = useState([]);
  const [eventos, setEventos] = useState({ results: [] });

  const [dadosPoco, setDadosPoco] = useState([]);
  const [dadosBomba, setDadosBomba] = useState([]);

  const [modalConfirmaBomba, setModalConfirmaBomba] = useState(false);
  const [modalConfirmaControler, setModalConfirmaControler] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenBomba, setModalIsOpenBomba] = useState(false);
  const [modalEventosFalhas, setModalEventosFalhas] = useState(false);
  const [modalAvisosEmegencia, setModalAvisosEmegencia] = useState(false);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDateBomba, setSelectedDateBomba] = useState(new Date());

  const [idDataPoco, setIdDataPoco] = useState(0);
  const [idDataBomba, setIdDataBomba] = useState(0);

  const [dataPoco, setDataPoco] = useState([]);
  const [dataBomba, setDataBomba] = useState([]);

  const [modalReladorioBombaOn, setModalRelatorioBombaOn] = useState(false);

  const [reversoOn, setReversoOn] = useState(false);
  const [ligarReversoModal, ligarSetReversoModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const [modalRelatoriosOn, setModalRelatoriosOn] = useState(false);

  const listarEventos = async (id_estacao) => {
    try {
      const response = await apiSae.get(
        `alertas/Leitura/${id_estacao}`,
        headerApi
      );
      setEventos(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // função para converção de valores (4a20)
  const convert4a20 = (ma) => {
    const minMa = 3.8;
    const maxMa = 20.2;
    const minPsi = 0;
    const maxPsi = 145;

    // Normaliza o valor de mA para um intervalo de 0-1
    const normalized = (ma - minMa) / (maxMa - minMa);

    // Converte o valor normalizado para o intervalo de psi
    let psi = normalized * (maxPsi - minPsi) + minPsi;

    // Formata para uma casa decimal e converte para número
    if (psi < 0) {
      psi = 0;
    }
    return Number(psi.toFixed(1));
  };

  const aoListarGeradores = async () => {
    try {
      const response = await apiSae.get("gerador/LeituraTodos", headerApi);
      setGeradores(response.data);
    } catch (error) {}
  };

  const fetchDadosBomba = async (id_bomba, date) => {
    try {
      const response = await apiSae.get(
        `/grafico/bomba/${id_bomba}?data=${date}`,
        headerApi
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar dados do poço:", error);
    }
  };

  useEffect(() => {
    aoListarGeradores();
  }, []);

  return (
    <ElevatoriaContext.Provider
      value={{
        geradores,
        dadosControle,
        setDadosControle,
        modalConfirmaBomba,
        setModalConfirmaBomba,
        idBombasLoading,
        setidBombasLoading,
        modalIsOpen,
        setModalIsOpen,
        modalIsOpenBomba,
        setModalIsOpenBomba,
        modalEventosFalhas,
        setModalEventosFalhas,
        selectedDate,
        setSelectedDate,
        selectedDateBomba,
        setSelectedDateBomba,
        eventos,
        setEventos,
        listarEventos,
        fetchDadosBomba,
        dadosPoco,
        setDadosPoco,
        idDataPoco,
        setIdDataPoco,
        dataPoco,
        setDataPoco,
        dadosBomba,
        setDadosBomba,
        idDataBomba,
        setIdDataBomba,
        dataBomba,
        setDataBomba,
        modalConfirmaControler,
        setModalConfirmaControler,
        modalAvisosEmegencia,
        setModalAvisosEmegencia,
        modalReladorioBombaOn,
        setModalRelatorioBombaOn,
        reversoOn,
        setReversoOn,
        ligarReversoModal,
        ligarSetReversoModal,
        loading,
        setLoading,
        modalRelatoriosOn,
        setModalRelatoriosOn,
      }}
    >
      <Outlet />
    </ElevatoriaContext.Provider>
  );
};
